import { Entity } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { Booking } from './Booking.js';

/**
 * The DonationBooking is the booking specifically for donations. It is only used to easily book someone to a school and only let trough the Spende BillingPosition.
 * @class DonationBooking
 * @extends Booking
 */
@Entity()
export class DonationBooking extends Booking {
  static override _class = 'DonationBooking';

  constructor(doc: PartialEntityData<DonationBooking>) {
    super(doc);
  }
}
